export default {
  minute: 'Minuto',
  hour: 'Hora',
  day: 'Día',
  week: 'Semana',
  month: 'Mes',
  quarter: 'Trimestre',
  autoWithPeriod: 'Auto ({period})',
};
